/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-05-25
 * @brief EHP Status 컴포넌트
 *
 ********************************************************************/
import React from "react";
// recoli & state
import { useRecoilValue } from "recoil";
import { userInfoLoginState, } from '../../../recoil/userState';
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
//import { isTemplateExpression } from "typescript";
/**
 * @brief EHP Status 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function ListDetail(props) {
    //const userInfo = useRecoilValue(userInfoState);
    const userInfo = useRecoilValue(userInfoLoginState);
    //
    const item = props.itemDetail;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "data-detail", className: "popup-layer js-layer layer-out hidden page-detail" },
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", null, "\uC0C1\uC138\uC815\uBCF4"),
                React.createElement("button", { className: "btn btn-close js-close" },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: "popup__body" },
                React.createElement("ul", { className: "datadetail-info" },
                    React.createElement("li", null,
                        React.createElement("p", null, "\uC2DC\uB9AC\uC5BC \uBC88\uD638"),
                        React.createElement("p", null, item.serialNo)),
                    React.createElement("li", null,
                        React.createElement("p", null, "\uB2F4\uB2F9\uC790"),
                        React.createElement("p", null, item.responsible)),
                    React.createElement("li", null,
                        React.createElement("p", null, "\uC704\uCE58"),
                        React.createElement("p", null, item.ehcPos)),
                    React.createElement("li", null,
                        React.createElement("p", null, "\uCD5C\uADFC\uC810\uAC80\uC77C"),
                        React.createElement("p", null, CUTIL.utc2time("YYYY-MM-DD", item.assessment.updatedTime)),
                        React.createElement("p", { className: "hide" }, "Step"),
                        React.createElement("ul", { className: (item.checkStep.name === "ADVANCED")
                                ? "icon-step all"
                                : (item.checkStep.name === "PREMIUM")
                                    ? "icon-step two"
                                    : (item.checkStep.name === "BASIC")
                                        ? "icon-step one"
                                        : "icon-step" },
                            React.createElement("li", null,
                                React.createElement("span", { className: "hide" }, "1\uB2E8\uACC4")),
                            React.createElement("li", null,
                                React.createElement("span", { className: "hide" }, "2\uB2E8\uACC4")),
                            React.createElement("li", null,
                                React.createElement("span", { className: "hide" }, "3\uB2E8\uACC4")))),
                    React.createElement("li", { className: "btnarea" },
                        React.createElement("div", null,
                            (item.assessment.reportId != null)
                                ? React.createElement("button", { type: "button", className: "btn btn-file", onClick: (e) => { HttpUtil.fileDownload_WithPdfViewer(item.itemName, item.assessment.reportId, userInfo.loginInfo.token); } },
                                    React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC"))
                                : React.createElement("button", { type: "button", className: "btn btn-file", disabled: true },
                                    React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC")),
                            React.createElement("p", null, "Report")),
                        React.createElement("div", null,
                            (item.assessment.totalComment == null)
                                ? React.createElement("button", { type: "button", className: "btn btn-memo", disabled: true },
                                    React.createElement("span", { className: "hide" }, "\uBA54\uBAA8"))
                                : React.createElement("button", { type: "button", className: "btn btn-memo" },
                                    React.createElement("span", { className: "hide" }, "\uBA54\uBAA8")),
                            React.createElement("p", null, "\uBA54\uBAA8")),
                        React.createElement("div", null,
                            React.createElement("button", { type: "button", className: "btn btn-file", disabled: true },
                                React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC")),
                            React.createElement("p", null, "\uC131\uC801\uC11C"))))))));
}
export default ListDetail;
